<button
  [ngClass]="[isTransparent ? 'transparent': '', buttonSize]"
  type="button"
  class="d-flex justify-content-center align-items-center p-0 m-0"
  (click)="buttonClick.emit()"
  (dblclick)="$event.stopPropagation()"
  [disabled]="disabled"
  [inlineSVG]="iconUrl">
</button>
